import { ActionButton, DocumentCard, Icon } from '@fluentui/react';
import { Utils } from '../../common/views/Utils';
import PhotoCollageView from '../../photoCollages/views/CollageView';
import { PhotoShapeManager } from '../../photoCollages/views/PhotoShapeManager';
import { NewFeedModel } from '../models/NewFeedModel';

type NewFeedRowProps = {
    feed: NewFeedModel;
    onEdit: (feed: NewFeedModel) => void;
    onDetail: (feed: NewFeedModel) => void;
    onActivate: (feed: NewFeedModel) => void;
    photoManager: PhotoShapeManager;
}

export default function NewFeedRowView({
    feed, onEdit, onDetail, onActivate, photoManager
}: NewFeedRowProps) {
    const width4 = Utils.getColumnWidth(4);

    const editButton = () => {
        return <>
            <ActionButton
                iconProps={{ iconName: "Edit" }}
                styles={{ icon: { color: "black" } }}
                onClick={() => onEdit(feed)}
            >Edit</ActionButton>
        </>;
    }

    const activateButton = () => {
        return <>
            <ActionButton
                iconProps={{ iconName: feed.active ? "ErrorBadge" : "Completed" }}
                styles={{ icon: { color: "black" } }}
                onClick={() => onActivate(feed)}
            >{feed.active ? "Deactivate?" : "Activated?"}</ActionButton>
        </>;
    }

    const detailButton = () => {
        return <>
            <ActionButton
                iconProps={{ iconName: "CheckList" }}
                styles={{ icon: { color: "black" } }}
                onClick={() => onDetail(feed)}
            >Detail</ActionButton>
        </>;
    }

    const actionRow = () => {
        return <div className="disable-action-button ms-Grid ph-5 primary-background-color">
            <div className="ms-Grid-row">
                <div className={width4 + " left"}>
                    {editButton()}
                </div>
                <div className={width4 + " center"}>
                    {activateButton()}
                </div>
                <div className={width4 + " right"}>
                    {detailButton()}
                </div>
            </div>
        </div>;
    }

    return <>
        <DocumentCard
            className="picture-wrapper order-product-picture-card ph-20"
            styles={{ root: { maxWidth: "100%" } }}>
            <div className="center">
                {feed.pictures.length > 0 && <>
                    <PhotoCollageView
                        feed={feed}
                        photoManager={photoManager}
                    />
                </>}

                {feed.pictures.length === 0 && <div>
                    <Icon iconName="" style={{ width: 200, height: 200 }} />
                </div>}
            </div>

            <div className="left ph-10">
                <div className="font-bold">{feed.brand}</div>
                <div className="pt-10">{feed.title}</div>
                <div className="pt-10">{feed.description}</div>
                <div className="pt-10">{actionRow()}</div>
            </div>
        </DocumentCard>
    </>;
}